// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#valid-sheets .header.item-container{grid-template-columns:5em 14em 1fr 10em;font-size:16px;padding:1em 0;color:#adadad}#valid-sheets .header.item-container .responsive-table .item-container{grid-template-columns:8em 6em 8em 180px 1.5fr}#valid-sheets .sheet-aggregate-list.empty,#valid-sheets .sheet-aggregate-list .load-content{min-height:20em}", ""]);
// Exports
module.exports = exports;
